import React from 'react';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useParams, useNavigate } from 'react-router-dom';
import AppsService from '../../../services/apps_service'
import { useDispatch } from 'react-redux';
import { fDateTime } from '../../../utils/formatTime';

import {
    Card,
    CardContent,
    Grid,
    Chip,
    Typography,
} from '@mui/material';
import Page from '../../../components/Page';
import AppWidgetSummary from '../app/AppWidgetSummary';
import LoadingScreen from 'react-loading-screen';
import { Paywall } from '../../../layouts/Paywall';
import { Container } from '@mui/system';

const useStyles = styled((theme) => ({
    root: {
        margin: '20px',

    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));

export default function AppInfoPage() {

    const params = useParams();
    const [appObj, setApp] = useState(null);
    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    function loadApp() {
        AppsService.getAppInfo(params.app_id, '')
            .then((response) => response.data)
            .then((data) => setApp(data))
            .then((data) => setIsLoading(false))
            .catch((error) => {
                if (error.response.status === 404) {
                    navigate('/404')
                }
            });
    }

    useEffect(() => {
        dispatch({ type: 'APP', payload: { 'app': params.app_id } })
    }, []);


    useEffect(() => {
        // if (isLoading) {
        loadApp();
        // loadRatingDistributions();
        // }
    }, []);

    useEffect(() => {
        return () => {
            dispatch({ type: '', payload: { 'app': params.app_id } })
        }
    }, [])

    if (isLoading) {
        return (
            <Paywall subscriptionPlan={2}>
                <Page title="App">
                    <LoadingScreen
                        loading={true}
                        bgColor="rgba(255,255,255,0.8)"
                        spinnerColor="#9ee5f8"
                        textColor="#676767"
                        logoSrc=""
                        text=""
                    >
                        {" "}
                    </LoadingScreen>
                </Page>
            </Paywall>
        )
    } else {
        return (
            <Paywall subscriptionPlan={2}>
                <Page title={appObj.app_name}>
                    <Grid container spacing={3}>

                        <Grid item xs={12} sm={6} md={3}>
                            <AppWidgetSummary title="Developer" total={appObj.developer} icon={'ant-design:audit-outlined'} ></AppWidgetSummary>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>

                            <AppWidgetSummary title="Release Date" total={fDateTime(appObj.release_date)} icon={'ant-design:calendar-outlined'}></AppWidgetSummary>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <AppWidgetSummary title="Current Version Release Date" total={fDateTime(appObj.current_version_release_date)} icon={'ant-design:calendar-outlined'}></AppWidgetSummary>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <AppWidgetSummary title="Version" total={appObj.version} icon={'ant-design:number-outlined'} ></AppWidgetSummary>

                        </Grid>
                        <Grid item xs={12} sm={6} md={9}>
                            <Card className={classes.root}>
                                <CardContent>
                                    <Typography variant="h5" component="h2">
                                        {appObj.app_name}
                                    </Typography>
                                    <Typography className={classes.pos} variant='body1' component="pre" gutterBottom={true} color="textSecondary">
                                        <pre style={{ fontFamily: 'inherit' }}>
                                            {appObj.description}
                                        </pre>


                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        {/* <Grid item xs={12} sm={4}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    Screenshots
                                </Typography>
                                {appObj.screenshots.map((screenshot, index) => (
                                    <img src={screenshot} key={index} alt={screenshot} />
                                ))}
                            </CardContent>
                        </Card>
                    </Grid> */}
                    </Grid >
                </Page >
            </Paywall>
        );
    }
}